// extracted by mini-css-extract-plugin
export var container = "section-feature-module--container--w5ALf";
export var contents = "section-feature-module--contents--i54Zx";
export var list = "section-feature-module--list--kXMQa";
export var item = "section-feature-module--item--RmVVw";
export var item_icon = "section-feature-module--item_icon--WJzOv";
export var item_title = "section-feature-module--item_title--Mbkuo";
export var item_desc = "section-feature-module--item_desc--3FGGI";